import { useNavigate } from 'react-router';

let navigateFn;

export const NavigateSetter = () => {
  // eslint-disable-next-line react-hooks/globals
  navigateFn = useNavigate();
  return null;
};

export const navigate = (to, options) => {
  if (navigateFn) navigateFn(to, options);
};
